import React from "react";
import { DatePicker } from '@mui/x-date-pickers'
import { 
    FormControl, 
    InputLabel, 
    Select, 
    OutlinedInput, 
    MenuItem, 
    Button,
    Snackbar
} from '@mui/material';
import BmwEventNumbers from '../../models/BmwEventNumbers';
import RestUtilities from '../../services/RestUtilities';
import EventOptions from '../../models/EventOptions';
import Events from '../../models/Events';
import Loader from '../../components/Loader';
import SnackbarWrapper from '../../components/SnackbarWrapper';
import Constants from '../../models/Constants' 
import { GrowMessage } from "../../components/GrowMessage";
import Auth from "../../stores/Auth";

class ReportsFilter {
    [key:string]: any
    bmwNumber: number
    eventId: number
    optionId: number
    dateFrom: Date = null
    dateTo: Date = null
}

class Reports extends React.Component<any, any> {

    state = {
        bmwNumbers: [] as BmwEventNumbers[],
        events: [] as Events[],
        options: [] as EventOptions[],
        filter: new ReportsFilter(),
        loading: false,
        message: '',
        showMessage: false
    }

    fetchBmwEventNumbers = (): void => {
        RestUtilities.get<BmwEventNumbers[]>('/api/BmwEventNumbers?active=true')
            .then(resp => {
                this.setState({ bmwNumbers: resp.content })
            })
    }

    fetchEventOptions = (): void => {
        RestUtilities.get<EventOptions[]>('/api/EventOptions?active=true')
            .then(resp => {
                this.setState({ options: resp.content })
            })
    }

    fetchEvents = (): void => {
        RestUtilities.get<Events[]>('/api/Events')
            .then(resp => {
                this.setState({ events: resp.content })
            })
    }

    handleChangeFilter = (event: any): void => {
        const newFilter = {...this.state.filter}
        const fieldName = event.target.name

        newFilter[fieldName] = event.target.value
        
        this.setState({ filter: newFilter })
    }

    clearFilters = (): void => {
        this.setState({ filter: new ReportsFilter() })
    }

    exportMemberList = () => {
        let url = '/api/Reports/MembersListReport?'

        this.exportExcel(url)
    }

    exportMemberSummary = () => {
        let url = '/api/Reports/MembersSummaryReport?'

        this.exportExcel(url)
    }

    exportAbrechnung = () => {
        let url = '/api/Reports/Abrechnung?'

        this.exportExcel(url)
    }

    getExcelExport = () => {
        let url = '/api/Reports/ExcelExport?'

        this.exportExcel(url)
    } 

    
    handleSnackbarClose = (event: any, reason: string) => {
        if (reason === 'clickaway')
            return;

        this.setState({ showMessage:false })
    }

    private exportExcel = (url: string): void => {
        this.setState({ loading: true })

        if (typeof this.state.filter.bmwNumber != 'undefined')
            url += `bmwNumberId=${this.state.filter.bmwNumber}&`

        if (typeof this.state.filter.eventId != 'undefined')
            url += `eventId=${this.state.filter.eventId}&`

        if (typeof this.state.filter.dateFrom !== 'undefined' && this.state.filter.dateFrom) {
            let date = new Date(this.state.filter.dateFrom)
            let dateString = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
            url += `dateFrom=${dateString}&`
        }

        if (typeof this.state.filter.dateTo !== 'undefined' && this.state.filter.dateTo) {
            let date = new Date(this.state.filter.dateTo)
            let dateString = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
            url += `dateTo=${dateString}&`
        }
          
        if (typeof this.state.filter.optionId != 'undefined')
            url += `optionId=${this.state.filter.optionId}`

        let xhr = new XMLHttpRequest();
        let self = this
        xhr.onreadystatechange = function () {
            if (xhr.readyState === XMLHttpRequest.DONE) {
                if (xhr.status === 200) {
                    if (xhr.response.size < 200) {
                        let reader = new FileReader()
                        reader.onload = () => {
                            let result = JSON.parse(reader.result as string)
                        }
                        reader.readAsText(this.response)
                        
                        self.setState({ loading: false })
                        return false
                    }
                    let fileName: string = ''
                    let disposition = xhr.getResponseHeader('Content-Disposition')

                    if (disposition != null) {
                        let startIndex = disposition!.indexOf('filename=') + 9
                        fileName = disposition!.substring(21, disposition!.length)
                    }

                    let blob = new Blob([this.response])
                    
                    let reader = new FileReader()
                    reader.onload = () => {
                        let result = {} as any
                        try {
                            result = JSON.parse(reader.result as string)
                        } catch(ex) {
                            RestUtilities.saveAs(blob, fileName)
                        }

                        if(result.error != null) {
                            self.setState({ loading: false, showMessage: true, message: result.error })
                            return
                        }
                    }

                    reader.readAsText(blob)

                    self.setState({ loading: false })

                }
            }
        }
    
        xhr.open('GET', url)
        xhr.setRequestHeader("Content-type", "application/json")
        xhr.setRequestHeader('Authorization',`Bearer ${Auth.getToken()}`);
        xhr.responseType = 'arraybuffer'
        xhr.send()
    }

    componentDidMount() {
        this.fetchBmwEventNumbers()
        this.fetchEventOptions()
        this.fetchEvents()
    }

    public render() {

        let numbers: JSX.Element[] = this.state.bmwNumbers.map(x => {
            return <MenuItem value={x.id}>{x.bmwnumber}</MenuItem>
        })

        let options: JSX.Element[] = this.state.options.map(x => {
            return <MenuItem value={x.id}>{x.description}</MenuItem>
        })

        let events: JSX.Element[] = this.state.events.map(x => {
            return <MenuItem value={x.id}>{x.eventName}</MenuItem>
        })

        return (
            
            <div>
                {this.state.loading && <Loader />}
                
                <h2 className='mt-3 title'>Berichte</h2>
                <div className='card'>
                    <div className='card-header'>
                        <h5>Filters</h5>
                    </div>
                    <div className='card-body'>
                        <div className='row'>
                            <div className='col-lg-6 col-md-6 col-sm-6 col-xs-6'>
                                <FormControl variant="outlined" fullWidth className='mt-3'>
                                    <InputLabel htmlFor="outlined-aktiv">
                                        BMW Nummer
                                    </InputLabel>
                                    <Select
                                        input={
                                            <OutlinedInput id='outlined-aktiv' fullWidth />
                                        }
                                        onChange={(e:any) => this.handleChangeFilter(e)}
                                        value={typeof this.state.filter.bmwNumber != 'undefined' ? this.state.filter.bmwNumber : ''}
                                        fullWidth
                                        name='bmwNumber'
                                    >
                                        <MenuItem value="">
                                            <em></em>
                                        </MenuItem>
                                        {numbers}
                                    </Select>
                                </FormControl>
                                <FormControl variant="outlined" fullWidth className='mt-3'>
                                    <InputLabel htmlFor="outlined-aktiv">
                                        Veranstaltung
                                    </InputLabel>
                                    <Select
                                        input={
                                            <OutlinedInput id='outlined-aktiv' fullWidth />
                                        }
                                        onChange={(e:any) => this.handleChangeFilter(e)}
                                        value={typeof this.state.filter.eventId != 'undefined' ? this.state.filter.eventId : ''}
                                        name='eventId'
                                        fullWidth
                                    >
                                        <MenuItem value="">
                                            <em></em>
                                        </MenuItem>
                                        {events}
                                    </Select>
                                </FormControl>
                                <FormControl variant="outlined" fullWidth className='mt-3'>
                                    <InputLabel htmlFor="outlined-aktiv">
                                        Option
                                    </InputLabel>
                                    <Select
                                        input={
                                            <OutlinedInput  id='outlined-aktiv' />
                                        }
                                        name='optionId'
                                        value={typeof this.state.filter.optionId != 'undefined' ? this.state.filter.optionId : ''}
                                        onChange={(e:any) => this.handleChangeFilter(e)}
                                        fullWidth
                                    >
                                    {options}
                                    </Select>
                                </FormControl>
                                <DatePicker 
                                    className='mt-3'
                                    label='Veranstaltungsdatum von:'
                                    name='dateFrom'
                                    value={this.state.filter.dateFrom ? new Date(this.state.filter.dateFrom): null}
                                    format={Constants.DateFormat}
                                    onChange={(newValue: any) => {
                                        let event = {
                                            target: {
                                                name: 'dateFrom',
                                                value: newValue                                            }
                                        }
                                        this.handleChangeFilter(event)
                                    }}
                                     />
                                    
                                <DatePicker 
                                    className='mt-3'
                                    label='Veranstaltungsdatum bis:'
                                    name='dateTo'
                                    value={this.state.filter.dateTo ? new Date(this.state.filter.dateTo) : null}
                                    format={Constants.DateFormat}
                                    onChange={(date: any) => {
                                        let event = {
                                            target: {
                                                name: 'dateTo',
                                                value: date
                                            }
                                        }
                                        this.handleChangeFilter(event)
                                    }}
                                    />
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-6 col-xs-6'>
                                <Button 
                                    variant='contained' 
                                    color='primary' 
                                    className='ml-5 mt-5'
                                    onClick={() => this.clearFilters()}>Filter zurücksetzen</Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row mt-3'>
                            <div className='col-sm-3'>
                                <Button 
                                    variant='contained' 
                                    color='primary' 
                                    className='btnBlue'
                                    onClick={() => this.getExcelExport()}>Excel Export</Button>
                            </div>
                            <div className='col-sm-3'>
                                <Button 
                                    variant='contained' 
                                    color='primary'
                                    className='btnBlue'
                                    onClick={() => this.exportMemberList()}>Teilnehmerliste</Button>
                            </div>
                            <div className='col-sm-3'>
                                <Button 
                                    variant='contained' 
                                    color='primary'
                                    className='btnBlue'
                                    onClick={() => this.exportMemberSummary()}>Teilnehmersumme</Button>
                            </div>
                            <div className='col-sm-3'>
                                <Button 
                                    variant='contained' 
                                    color='primary'
                                    className='btnBlue'
                                    onClick={() => this.exportAbrechnung()}>Abrechnung</Button>
                    </div>
                </div>
                <GrowMessage
                    anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                    }}
                    message={this.state.message}
                    visible={this.state.showMessage}
                    autoHideDuration={6000}
                    onClose={this.handleSnackbarClose} ></GrowMessage>  
                {/* <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    open={this.state.showMessage}
                    autoHideDuration={6000}
                    onClose={this.handleSnackbarClose}
                >
                    <SnackbarWrapper
                        onClose={this.handleSnackbarClose}
                        variant="success"
                        message={this.state.message}
                    />
                </Snackbar> */}
            </div>
        )
    }
}

export default Reports